import styled from "styled-components";

import { MediaBreakpoints } from "../../Styles";

export const ChangeEditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;

  button {
    margin: 10px auto;
  }

  @media ${MediaBreakpoints.small} {
    flex-direction: row;
    button {
      margin: 0 4px;
    }
  }

  @media ${MediaBreakpoints.medium} {
    flex-direction: row;
    justify-content: center;

    button {
      margin: 10px;
    }
  }

  @media ${MediaBreakpoints.wide} {
    justify-content: center;
    gap: 16px;
    margin-bottom: 40px;

    button {
      margin: 5px auto;
    }
  }
`;
